import React, { useState } from "react";

import { ConfigProvider, theme } from "antd";

import { AppProvider } from "src/context";

import { notification } from "antd";

import PWAInit from "src/PWAInit";

import en_US from "antd/lib/locale/en_US";

import ConnectionLostOverlay from "src/ConnectionLostOverlay";

import Routes from "src/Routes";
import RealTime from "./Realitime";
import coreFunctions from "./common/utils/coreFunctions";
import BackgroundUploader from "./common/components/BackgroundUpload";

import "./App.css";

const App: React.FC = () => {
  const [hasInternet, setHasInternet] = useState(true);
  const [api, contextHolder] = notification.useNotification();

  return (
    <ConfigProvider
      theme={{
        algorithm: coreFunctions.isMobileDevice()
          ? theme.defaultAlgorithm
          : theme.compactAlgorithm,
      }}
      locale={en_US}
    >
      <AppProvider>
        <PWAInit />
        <ConnectionLostOverlay hasInternet={hasInternet} />
        <RealTime setHasInternet={setHasInternet} />
        <Routes />
        {contextHolder}
        <BackgroundUploader />
      </AppProvider>
    </ConfigProvider>
  );
};

export default App;
